import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import getMagicLink from "../../Actions/magicLinkAction";
import {MAGIC_LINK} from "../../Reducers/magicLinkReducer";
import LoadingSpinner from "../CommonComponents/loadingSpinner";

let linkTracker = "";
const MagicLink = ({selectedAdminId, selectedCompanyId}) => {
    const dispatch = useDispatch();
    const magicLinkObj = useSelector(state => state.magicLink);
    const [showLoading, setShowLoading] = useState(false);
    const [newLink, setNewLink] = useState("");

    const handleClick = () => {
        setShowLoading(true);
        dispatch(getMagicLink(selectedAdminId, selectedCompanyId));
    }

    useEffect(() => {
        if (magicLinkObj !== null && linkTracker !== magicLinkObj.getMagicLink()) {
            linkTracker = magicLinkObj.getMagicLink();
            window.open(magicLinkObj.getMagicLink(), '_blank'); //'location=yes, height=570, width=520, scrollbars=yes, status=yes'
        }

        setShowLoading(false);

        return () => {
            dispatch({
                type: MAGIC_LINK,
                payload: null
            })
        }
    }, [magicLinkObj]);


    return (
        <span className={`dropdown-item ${showLoading? 'disabledLoading':''}`} onClick={handleClick} title={"Get access to the account"}>
            Access Dispatch Dashboard
        </span>
    )
}

export default MagicLink;
